export enum ProfileSearchEnum {
  PropertySearch = 'propertySearch',
  PropertySearchWalkingFarm = 'propertySearchWalkingFarm',
  WalkingFarm = 'walkingFarm'
}

export enum ProfileAdvancedSearchTabEnum {
  CityState = 'cityState',
  ZipCode = 'zipCode'
}
